import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "./redux/multiLocationSagas";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import DatePicker from "./smartComponents/datePicker";
import PreviousDatePicker from "./smartComponents/previousDatePicker";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import FilterLevelFirstSelect from "./smartComponents/filterLevelFirstSelect";
import FilterLevelSecondSelect from "./smartComponents/filterLevelSecondSelect";
import FilterLevelThirdSelect from "./smartComponents/filterLevelThirdSelect";
import FilterLevelFourSelect from "./smartComponents/filterLevelFourSelect";
import GroupBy from "./smartComponents/groupBy";
import CustomDateRanges from "./smartComponents/customDateRanges";
import ConversionsTableHeader from "./smartComponents/ConversionsTableHeader";
import RevenueTableHeader from "./smartComponents/revenueTableHeader";
import { UpdateBtns } from "./smartComponents/UpdateBtns";
import RevenueType from "./smartComponents/revenueType";

import "./multiLocation.css.scss";

const MultiLocationModule = (props) => {
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.multiLocation.isLoading);

  useEffect(() => {
    dispatch(actionCreators.fetchTableData(props));
  }, []);

  const content = (
    <>
      <div className={`edit-selections-bar edit-selections-barr `} style={{ height: "220px" }}>
        <div className="dates-container">
          <RevenueType />
          <div className="date-range-select-box">
            <p className="offers-title">Date Range</p>
            <CustomDateRanges />
          </div>
          <div className="date-select-box multi" style={{ width: 302 }}>
            <p>Date</p>
            <DatePicker
              calendarStartDate={props.calendarStartDate}
              calendarEndDate={props.calendarEndDate}
            />
          </div>
          <PreviousDatePicker calendarStartDate={props.calendarStartDate} />
        </div>
        <div className="filters-container">
          <div className="select-box" style={{ width: 200 }}>
            <FilterLevelFirstSelect />
          </div>

          <div className="select-box" style={{ width: 200 }}>
            <FilterLevelSecondSelect />
          </div>

          <div className="select-box" style={{ width: 200 }}>
            <FilterLevelThirdSelect />
          </div>

          <div className="select-box" style={{ width: 200 }}>
            <FilterLevelFourSelect />
          </div>

          <GroupBy />

          <div className="action-buttons">
            <UpdateBtns params={props} />
          </div>
        </div>
      </div>

      <Tables />
    </>
  );

  return (
    <div className="multi-location-module universal">
      <SectionToggle
        autoHeight
        title="Universal"
        customClass="multi-location-comparison"
        isLoading={isLoading}
        hideToggle
        content={content}
      />
    </div>
  );
};

const Tables = () => {
  const tablesLoading = useSelector((state) => state.multiLocation.tablesLoading);

  return tablesLoading ? (
    <LoadingAnimation text="Updating tables..." />
  ) : (
    <div className="multilocation-sections">
      <RevenueTableHeader />
      <ConversionsTableHeader />
    </div>
  );
};

export default MultiLocationModule;
